/**
 * Table_Service.ts
 * CRUD + lifecycle for hospitality floor tables (adapter /v1/tables).
 */

import { apiClient } from '../../api/axiosInstance';
import { Hosp_Tables_Url, Hosp_Table_Url, Hosp_Table_Free_Url } from '../../api/endpoints';
import type { FloorTable, CreateFloorTableInput, UpdateFloorTableInput } from '../../schemas/config/table';

export const getFloorTables = async (locationId?: string): Promise<FloorTable[]> => {
  const { data } = await apiClient.get<FloorTable[]>(Hosp_Tables_Url, {
    params: locationId ? { locationId } : undefined,
  });
  return data;
};

export const createFloorTable = async (input: CreateFloorTableInput): Promise<FloorTable> => {
  const { data } = await apiClient.post<FloorTable>(Hosp_Tables_Url, input);
  return data;
};

export const updateFloorTable = async (id: string, input: UpdateFloorTableInput): Promise<FloorTable> => {
  const { data } = await apiClient.patch<FloorTable>(Hosp_Table_Url(id), input);
  return data;
};

export const deactivateFloorTable = async (id: string): Promise<void> => {
  await apiClient.delete(Hosp_Table_Url(id));
};

// For a table with no linked queue entry (a direct walk-in) — releaseWaitlistEntry
// requires an entryId and can never be called for these, so without this call the
// floor row never actually clears even after its bill settles.
export const freeFloorTableWithoutEntry = async (id: string): Promise<void> => {
  await apiClient.post(Hosp_Table_Free_Url(id));
};
